// EditDoctor Component for updating doctor data

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import MandalInfoForm from "../Forms/MandaliInfoForm";
import CONFIG from "../../config";
import { usePatient } from "../../context/PatientContext";
import { useTheme } from "../../context/ThemeContext";

const EditDoctor = () => {
  let { id } = useParams();
  const [doctorInfo, setDoctorInfo] = useState(null);
  const baseURL = CONFIG.BASE_URL;
  let navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const userData = usePatient();
  const { theme, isDarkMode } = useTheme();

  useEffect(() => {
    if (!id) {
      console.error("Doctor ID is undefined. Cannot fetch data.");
      return;
    }
    axios.get(`${baseURL}/doctors/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        doctorId: userData.doctorInfo.MANDALI_ID,
        clinicId: userData.doctorInfo.CLINIC_ID,
        roleid: userData.doctorInfo.MANDALI_ROLE
      }
    })
      .then((res) => {
        setDoctorInfo(res.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          alert("Doctor not found! Redirecting...");
          navigate("/doctors");
        } else {
          console.error('Error fetching doctor details:', err);
        }
      });
  }, [id]);

  const onSubmitHandler = (updatedDoctorData, options = {}) => {
    updateDoctorData(updatedDoctorData, options);
  };

  const updateDoctorData = async (doctorInfo, options = {}) => {
    const isAutoSave = options?.isAutoSave;
    try {
      const response = await axios.put(`${baseURL}/doctors/update/${doctorInfo.MANDALI_ID}`, doctorInfo, {
        headers: {
          Authorization: `Bearer ${token}`,
          doctorId: userData.doctorInfo.MANDALI_ID,
          clinicId: userData.doctorInfo.CLINIC_ID,
          roleId: userData.doctorInfo.MANDALI_ROLE
        }
      });

      console.log('Update response:', response.data);
      if (!isAutoSave) {
        alert("Doctor updated successfully");
        if (userData.doctorInfo.MANDALI_ROLE === 1) {
          navigate("/doctorslist");
        } else {
          navigate("/getmandaliinfo");
        }
      }
    } catch (error) {
      console.error('Error updating doctor:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div
      className="min-h-screen w-full transition-colors duration-700 ease-in-out flex items-center justify-center p-2 md:p-8"
      style={{
        color: theme.text
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full max-w-4xl rounded-2xl md:rounded-[2.5rem] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.3)] transition-all duration-500 overflow-hidden"
        style={{
          backgroundColor: theme.card,
        }}
      >
        {/* Header Section */}
        <div className="px-4 md:px-12 pt-8 md:pt-10 pb-6 border-b" style={{ borderColor: theme.border }}>
          <h2
            className="text-2xl md:text-3xl mb-2 tracking-tight"
            style={{
              fontFamily: theme.fonts?.serif,
              color: theme.text
            }}
          >
            Edit Mandali Information
          </h2>
          <div className="h-1 w-20 rounded-full" style={{ backgroundColor: theme.primary }} />
          <p className="text-sm mt-4 font-medium" style={{ color: theme.textSecondary }}>
            Update the profile details and credentials below.
          </p>
        </div>

        {/* Form Section */}
        <div className="px-4 md:px-12 py-8">
          {doctorInfo && (
            <MandalInfoForm
              initialValues={doctorInfo}
              onSubmit={onSubmitHandler}
              onAutoSave={(values) => onSubmitHandler(values, { isAutoSave: true })}
              enableReinitialize={true}
            />
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default EditDoctor;
